import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HolidayApi, CreateHolidayApi, EditHolidayApi } from '../../models/holiday/holiday-api.model';

const OPT = { withCredentials: true } as const;

@Injectable({ providedIn: 'root' })
export class HolidayService {
    constructor(private http: HttpClient) {}

    getHolidays(year?: number): Observable<{ holidays: HolidayApi[] }> {
        const params: Record<string, string> = {};
        if (year != null) params['year'] = String(year);
        return this.http.get<{ holidays: HolidayApi[] }>(
            environment.holidays.root, { ...OPT, params },
        );
    }

    getHolidayByGuid(guid: string): Observable<{ holiday: HolidayApi | null }> {
        return this.http.get<{ holiday: HolidayApi | null }>(
            `${environment.holidays.root}/${guid}`, OPT,
        );
    }

    createHoliday(payload: CreateHolidayApi): Observable<{ holiday: HolidayApi }> {
        return this.http.post<{ holiday: HolidayApi }>(
            environment.holidays.root, payload, OPT,
        );
    }

    editHoliday(guid: string, payload: EditHolidayApi): Observable<{ holiday: HolidayApi }> {
        return this.http.put<{ holiday: HolidayApi }>(
            `${environment.holidays.root}/${guid}`, payload, OPT,
        );
    }

    deleteHoliday(guid: string): Observable<{ success: boolean }> {
        return this.http.delete<{ success: boolean }>(
            `${environment.holidays.root}/${guid}`, OPT,
        );
    }
}
